import React, { useMemo } from "react";
import { LoadingComponent } from "@gooddata/sdk-ui";

import { TrendChart } from "../Visualization/TrendChart";

function BasketLineChart({ rolledForwardTrendPoints, kpiSettings, title, subtitle = undefined, categories, minValue, maxValue, data = [], width = null, height = null, chartProps = {}, custIndex, filters, displayMode, ...props }) {
    const settingsAliases = useMemo(
        () => ({
            flag_ser: "Maintenance",
            flag_bre: "Breakdown",
            flag_ins: "Insurance",
            flag_rep: "Replacement",
            flag_fin: "Financial loss",
            flag_co2: "CO2 Malus",
            flag_tyr: "Tyres",
            flag_win: "Winter Tyres",
            flag_evb: "EV Bonus",
            flag_insuranced: "Damage Insurance",
            flag_insurancetpl: "TPL Insurance",
        }),
        [],
    );
    const services = useMemo(
        () =>
            Object.keys(kpiSettings)
                .filter((key) => kpiSettings[key] === true)
                .map((key) => settingsAliases[key]),
        [kpiSettings, settingsAliases],
    );
    return data.length <= 0 ? (
        <div className="p-10">
            <LoadingComponent />
        </div>
    ) : (
        <div className={props.widgetUid ? "justify-center items-center w-full h-full" : "border-2 border-gray-300 rounded"} style={props.widgetUid ? { width: "100%", height: "100%" } : {}}>
            <TrendChart
                rolledForwardTrendPoints={rolledForwardTrendPoints}
                services={services}
                metadata={{ custIndex, displayMode, flag_services: kpiSettings }}
                section={"basketline"}
                filters={filters}
                id={"basket-line-chart"}
                title={title}
                subtitle={subtitle}
                categories={categories}
                legendStyle={{
                    fontSize: "10px",
                    fontWeigth: "600",
                    color: "#595959",
                }}
                series={data}
                width={width}
                height={height}
                {...chartProps}
                minValue={minValue}
                maxValue={maxValue}
                {...props}
                caption={
                    rolledForwardTrendPoints && rolledForwardTrendPoints.size > 0
                        ? {
                              text: '<div style="display: flex; align-items: center; font-size: 10px; color: #666666; margin-bottom: 4px;"><svg width="12" height="12" viewBox="0 0 12 12" style="margin-right: 4px;"><circle cx="6" cy="6" r="4" fill="#BFBFBF" stroke="#506e96" stroke-width="4"/></svg><span>Points with gray center are from previous month</span></div>',
                              useHTML: true,
                              align: "left",
                              verticalAlign: "bottom",
                              y: 15,
                              x: 10,
                          }
                        : {}
                }
            />{" "}
        </div>
    );
}

export { BasketLineChart };
